baseApp.directive('passwordform', function() {
    return {
        templateUrl: '/public/directives/passwordform.html',
        scope: {
            pw: "=",
            form: "=",
            labelWidth: "@",
        },
        link:function($scope, $element){
            $scope.maskedpw = null;

            if(!$scope.labelWidth){
               $scope.labelWidth = 3;
            }
            $scope.showPassword = function(){
                $($element[0]).find('.password').attr('type','text');

//                $("#passwordfield").attr('type','text');
            };
            $scope.hidePassword = function(){
                 $($element[0]).find('.password').attr('type','password');
            };
        }


    };
});